import React from 'react';
import { StyleSheet, View } from "react-native";
import { ThemedBlockStyles, ThemedShared } from "styles/themed";
import _ from "lodash";
import HelperValidate from 'utils/helper-validate'
import ThemedBlockTitle from 'components/atoms/ThemedBlockTitle'
import Text from "theme/Text";
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { parseThemedProps } from 'utils/helper-theme'

const ThemedBlock = ({ header, headerButton = {}, footer, footerStyle = {}, style = {}, containerStyle = {}, testID = null, onLayout, onPress, ...props }) => {
	
	const themedProps = parseThemedProps( props )
	
	let hasShadow = false;
	if( themedProps.shadow ) {
		props[ 'shadow' ] = null;
		hasShadow = true;
	}
	
	const contentStyles = [
		ThemedBlockStyles.container,
		!hasShadow ? {} : staticStyles.contentStylesMarginVertical0MarginHorizontal0,
		!HelperValidate.isValid( header ) ? {} : staticStyles.contentStylesBorderTopLeftRadius0BorderTopRightRadius0,
		...themedProps.themedStyles,
		themedProps.style ?? {},
		style,
	];
	
	if( hasShadow ) {
		containerStyle = {
			...StyleSheet.flatten( containerStyle ),
			...ThemedShared.bordered,
		};
	}
	
	let headerContent = null;
	if( HelperValidate.isValid( header ) ) {
		switch( true ) {
			case !_.isString( header ) && !_.isArray( header ):
				headerContent = header;
				break;
				
			case _.isString( header ):
				headerContent = (
					<HeaderRow>
						<HeaderTitle>
							{ header }
						</HeaderTitle>
					</HeaderRow>
				)
				break;
				
			case _.isArray( header ):
				headerContent = (
					<HeaderRow>
						{ _.map( header, (line, lineNr) => {
							if( lineNr > 0 ) {
								return (
									<Text>
										{ line }
									</Text>
								)
							}
							
							return (
								<HeaderTitle>
									{ line }
								</HeaderTitle>
							)
						}) }
					</HeaderRow>
				);
				break;
		}
	}
	
	let footerContent = null;
	if( HelperValidate.isValid( footer ) ) {
		footerContent = (
			<View
				style={ [
					ThemedBlockStyles.footerHeaderContainer,
					ThemedBlockStyles.footerContainer,
					footerStyle
				] }>
				
				{ footer }
			</View>
		)
	}
	
	return (
		<View
			testID={ testID }
			style={ containerStyle }>
			
			{/* Header */}
			{ headerContent }
			
			{/* Body */}
			<View
				onPress={ onPress }
				style={ contentStyles }>
				
				{ props.children }
			</View>
			
			{/* Footer */}
			{ footerContent }
		</View>
	);
}

const HeaderTitle = ( props ) => {
	return (
		<ThemedBlockTitle
			style={ staticStyles.themedBlockTitleMarginBottom0 }>

			{ props.children }
		</ThemedBlockTitle>
	);
};

export const HeaderRow = ({ headerButton = {}, style= {}, children }) => {
	const headerStyles = [
		ThemedBlockStyles.header,
		style
	]
	
	let headerButtonContent = null;
	if( !_.isEmpty( headerButton ) ) {
		headerButtonContent = (
			<Column
				style={ ThemedBlockStyles.headerColumn }>
				
				{ headerButton }
			</Column>
		)
	}
	
	return (
		<Grid>
			<Container>
				<Row>
					<Column>
						<View
							style={ headerStyles }>
							
							{ children }
						</View>
					</Column>
					
					{ headerButtonContent }
				</Row>
			</Container>
		</Grid>
	)
}

const staticStyles = StyleSheet.create({
	contentStylesMarginVertical0MarginHorizontal0: {
		marginVertical: 0,
		marginHorizontal: 0,
		paddingVertical: 0,
		paddingHorizontal: 0,
	},
	contentStylesBorderTopLeftRadius0BorderTopRightRadius0: {
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
	},
	themedBlockTitleMarginBottom0: {
		marginBottom: 0,
	},
});

export default ThemedBlock
